module.exports = __webpack_public_path__ + "static/media/company.3da28429.png";